import React from 'react';
import { PaginationType } from '../../../utils/pagination';
import './Pagination.css';
import { ReactComponent as ArrowLeftIcon } from '../../../assets/icons/angle-left.svg';
import { ReactComponent as ArrowRightIcon } from '../../../assets/icons/angle-right.svg';
import { ReactComponent as MoreIcon } from '../../../assets/icons/more-line.svg';
import classNames from 'classnames';

interface paginationProps {
  isMobile?: boolean;
  pagination: PaginationType;
  withCounts?: boolean;
  haveLastPage?: boolean;
  onPageClick: (targetPage: number) => void;
}

const Pagination = ({
  isMobile,
  pagination,
  haveLastPage,
  onPageClick,
}: paginationProps) => {
  const handleClick = (targetPage: number) => {
    if (
      targetPage < 1 ||
      targetPage > pagination.totalPages ||
      targetPage === pagination.currentPage
    )
      return;

    onPageClick(targetPage);
  };

  return (
    <div className="pagination-background">
      <div className={classNames('pagination', { mobile: isMobile })}>
        <div className="page-list">
          <button
            type="button"
            className={`page-item prev ${pagination.currentPage === 1 ? 'disabled' : ''}`}
            disabled={pagination.currentPage === 1}
            onClick={() => handleClick(pagination.prev)}
          >
            <ArrowLeftIcon />
          </button>
          {pagination.hasPrev10 && pagination.currentPage !== 1 && (
            <button
              type="button"
              className={`page-item`}
              onClick={() => handleClick(1)}
            >
              1
            </button>
          )}
          {pagination.hasPrev10 && (
            <button
              type="button"
              className={`page-item no-border`}
              onClick={() => handleClick(pagination.prev10)}
            >
              <MoreIcon />
            </button>
          )}
          {pagination.pages.map((v, i) => (
            <button
              type="button"
              key={`pagination${i}`}
              className={`page-item${
                v === pagination.currentPage ? ' selected' : ''
              }`}
              onClick={() => handleClick(v)}
            >
              {v}
            </button>
          ))}
          {pagination.hasNext10 &&
            pagination.endPage + 1 !== pagination.totalPages && (
              <button
                type="button"
                className={`page-item no-border ${!haveLastPage ? 'disabled' : ''}`}
                disabled={!haveLastPage}
                onClick={() => handleClick(pagination.next10)}
              >
                <MoreIcon />
              </button>
            )}
          {haveLastPage &&
            pagination.hasNext10 &&
            pagination.currentPage !== pagination.totalPages && (
              <button
                type="button"
                className={`page-item`}
                onClick={() => handleClick(pagination.totalPages)}
              >
                {pagination.totalPages}
              </button>
            )}
          <button
            type="button"
            className={`page-item next ${pagination.currentPage === pagination.totalPages ? 'disabled' : ''}`}
            disabled={pagination.currentPage === pagination.totalPages}
            onClick={() => handleClick(pagination.next)}
          >
            <ArrowRightIcon />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
